<template>
  <div :class="['metric-node', { 'metric-node--temperature': variant === 'temperature' }]">
    <template v-if="variant === 'temperature'">
      <div class="temperature-content">
        <div class="temperature-value">
          <span>{{ displayValue }}</span>
          <sup>{{ unit }}</sup>
        </div>
        <div class="temperature-label">{{ label }}</div>
      </div>
    </template>
    <template v-else>
      <div class="metric-label">{{ label }}</div>
      <div class="metric-value">
        <span>{{ displayValue }}</span>
        <em>{{ unit }}</em>
      </div>
    </template>
  </div>
</template>

<script>
import { parseRuntimeMetrics } from "../../utils/protocol/runtime";

const PRECISION_BY_METRIC = {
  temperature: 0,
  inletPressure: 2,
  inletFlow: 2,
  membranePressure: 2,
  pureWaterFlow: 2,
  rawWaterTotal: 2,
  pureWaterTotal: 2,
  supplyPressure: 2,
  supplyFlow: 2
};

export default {
  name: "DeviceMetricNode",
  props: {
    protocol: {
      type: Object,
      default: () => ({})
    },
    metric: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    unit: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: "default"
    }
  },
  computed: {
    displayValue() {
      const value = parseRuntimeMetrics(this.protocol)[this.metric];
      const precision = PRECISION_BY_METRIC[this.metric] || 0;
      return Number.isFinite(value) ? value.toFixed(precision) : "--";
    }
  }
};
</script>

<style scoped>
.metric-node {
  box-sizing: border-box;
  color: #fff;
  padding: 5px 8px;
}

.metric-label,
.temperature-label {
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}

.metric-value {
  line-height: 26px;
  white-space: nowrap;
}

.metric-value span {
  color: #fff;
  font-size: 18px;
  font-weight: 500;
}

.metric-value em {
  margin-left: 4px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-style: normal;
}

.metric-node--temperature {
  padding: 0;
}

.temperature-content {
  display: flex;
  height: 100%;
  margin-left: 76px;
  flex-direction: column;
  justify-content: space-evenly;
}

.temperature-value {
  display: flex;
  align-items: flex-start;
}

.temperature-value span {
  color: #438eff;
  font-size: 28px;
  font-weight: 500;
}

.temperature-value sup {
  margin: 3px 0 0 4px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-style: normal;
  line-height: 1;
}
</style>
